export const REFUEL_MESSAGES = {
  PREVIEW_DESCRIPTION:
    'A data indicada corresponde à <strong>previsão</strong> do seu abastecimento. <strong>Caso haja necessidade de alteração, a Ultragaz realizará até as 16h do dia anterior.</strong> Recomendamos que <strong><u>confirme a programação próximo à data.</u></strong>',
  SELECT_BASE:
    'Selecione o local de abastecimento para visualizar a previsão do seu próximo reabastecimento.',
  UNABLE_TO_CALCULATE:
    'Não foi possível calcular a previsão do próximo abastecimento. Por favor, tente novamente mais tarde.',

  BLOCKED:
    'A data do seu próximo abastecimento está <strong>temporariamente indisponível</strong>. Clique no botão abaixo para ver o(s) item(ns) que precisam ser regularizados para liberação do abastecimento',
  UNAVAILABLE_LABEL: 'Indisponível',
  BLOCKED_CTA: 'Ver itens',
};
